export const TYPES = {
  SELECT_USERS_SUCCESS: "user/SELECT_USERS_SUCCESS",
  SELECT_USER_SUCCESS: "user/SELECT_USER_SUCCESS",
};
